// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Yz_V","label":"styles_label__1_JAj"};